import { IUserOverview, UserNameable } from '../lib/types';

export function buildName(givenName?: string, familyName?: string): string {
  if (!givenName && !familyName) return '';
  if (!givenName && familyName) return familyName;
  if (!familyName && givenName) return givenName;
  return givenName + ' ' + familyName;
}

export function getName(userVariant?: (UserNameable & { user?: IUserOverview }) | null): string {
  if (!userVariant) return '';
  return (
    (buildName(
      userVariant.givenName ?? userVariant.user?.givenName,
      userVariant.familyName ?? userVariant.user?.familyName
    ) ||
      userVariant.user?.email) ??
    ''
  );
}

export function splitName(fullName?: string): {
  givenName: string;
  familyName: string;
} {
  if (!fullName) return { givenName: '', familyName: '' }; // If no name is provided, return empty strings
  const parts = fullName.trim().split(/\s+/); // Split by spaces and remove extra whitespace

  if (parts.length === 1) {
    return { givenName: parts[0], familyName: '' }; // If there's only one name, assume it's the given name
  }

  const familyName = parts.pop() || ''; // Get the last element as family name
  const givenName = parts.join(' '); // Join the rest as given name

  return { givenName, familyName };
}
